// extracted by mini-css-extract-plugin
export default {"root":"ApprovedIcon-root-99aa3f2fe144a5c3c6fcdcf9e05c97da"};